import dayjs, { Dayjs } from "dayjs"

import { Datasets } from "../../../constants/enums"
import { objectOnCondition } from "../../../utils/general/generalUtils"

export interface IStandard {
    standard: string
    partialTT: string
    fullTT: string
}

interface IStandards {
    GB: IStandard[]
    NI: IStandard[]
}

interface ISingleDeviceInput {
    header: Record<string, string>
    status: Record<string, string>
    content: Record<string, Record<string, number | string>>
    standards?: IStandards
    alert?: IAlert
    comments?: IComment[]
    pinnedComment?: string
}

export interface IAlert {
    description: string
    alerterUsername: string | null
    alerterGivenName: string | null
    alerterFamilyName: string | null
    alerterOrganisation: string | null
    raisedAt: string
}

export interface IComment {
    id: string
    comment: string
    publishedAt: string
    firstName: string | null
    lastName: string | null
    initials: string | null
    groupType: string | null
    fromRequestor: boolean
}

interface IHeader {
    deviceRef: string
    manufacturer: string
    status: string
    alert?: IAlert
    comments?: IComment[]
    pinnedComment?: string
    publishedDate: Dayjs
    supersededDeviceRef?: string
    draftVersionRef?: string
    draftAmendmentRef?: string
    attachmentUuid?: string
}

export interface ISingleDevice {
    header: IHeader
    content: Record<string, Record<string, number | string>>
    standards?: IStandards
}
export const singleDeviceMapper = {
    /**
     * Maps single device response into UI data model. This applies to both
     * generation and demand
     * @param response - raw API response
     * @returns {ISingleDevice} - UI data model for a single device
     */
    mapDevice: (response: unknown, dataset: Datasets): ISingleDevice => {
        const resTyped = response as ISingleDeviceInput
        return {
            header: {
                deviceRef:
                    resTyped?.header?.["Model Ref"] ??
                    resTyped?.header?.["System Reference"],
                manufacturer: resTyped?.header?.Manufacturer,
                status: resTyped?.status?.["Compliance Status"],
                alert: resTyped?.alert,
                comments: resTyped?.comments,
                pinnedComment: resTyped?.pinnedComment,
                publishedDate: dayjs(
                    resTyped?.content?.["Other Details"]?.["Date Published"]
                ),
                supersededDeviceRef: resTyped?.header?.["Superseded Model Ref"],
                draftVersionRef: resTyped?.header?.["Draft Version Ref"],
                draftAmendmentRef: resTyped?.header?.["Draft Amendment Ref"],
                attachmentUuid: resTyped?.header?.["Attachment UUID"],
            },
            content: resTyped?.content,
            ...objectOnCondition(
                dataset === Datasets.TTR || dataset === Datasets.TTR_DRAFT,
                {
                    standards: resTyped?.standards,
                } as {
                    [key: string]: unknown
                }
            ),
        }
    },
}
